var map = {
	"./A' bheilg.mp3": 67702,
	"./A' bhreatann bheag.mp3": 28983,
	"./A' chuimrigh.mp3": 81708,
	"./A' chòrn.mp3": 60442,
	"./A' ghearmailt.mp3": 18520,
	"./A' phortagail.mp3": 25859,
	"./A' phòlainn.mp3": 15836,
	"./Afraga a deas.mp3": 86085,
	"./An eadailt.mp3": 91766,
	"./An eilbheis.mp3": 71585,
	"./An fhraing.mp3": 67536,
	"./An ostair.mp3": 84578,
	"./An roinn-eòrpa.mp3": 15054,
	"./An ruis.mp3": 79361,
	"./An rìoghachd aonaichte.mp3": 68422,
	"./An spàinn.mp3": 1156,
	"./An t-suain.mp3": 28795,
	"./An tuirc.mp3": 34321,
	"./Anna.mp3": 43125,
	"./Anndra.mp3": 76577,
	"./Aonghais.mp3": 26806,
	"./Aonghas.mp3": 48072,
	"./Arcaibh.mp3": 11542,
	"./Astràilia.mp3": 78905,
	"./Breatainn.mp3": 59458,
	"./Calum.mp3": 69509,
	"./Catrìona.mp3": 51032,
	"./Didòmhnaich.mp3": 6915,
	"./Dòmhnall.mp3": 12378,
	"./Ealasaid.mp3": 56203,
	"./Eilean mhanainn.mp3": 80834,
	"./Eilidh.mp3": 40416,
	"./Eubha.mp3": 2258,
	"./Eòghainn.mp3": 31087,
	"./Eòghann.mp3": 94679,
	"./Fearghas.mp3": 25657,
	"./Fhearghais.mp3": 32967,
	"./Fhionnlaigh.mp3": 7780,
	"./Fionnlagh.mp3": 23161,
	"./Flòraidh.mp3": 57062,
	"./Frìseal.mp3": 59467,
	"./Fìobha.mp3": 18791,
	"./Iain.mp3": 94596,
	"./Iapan.mp3": 70605,
	"./Inbhir àir.mp3": 69761,
	"./Innis tìle.mp3": 61450,
	"./Irn bru.mp3": 8168,
	"./Iseabail.mp3": 61693,
	"./Leagsaidh.mp3": 24223,
	"./Mairead.mp3": 19150,
	"./Malaig.mp3": 39626,
	"./Màiri.mp3": 42131,
	"./Mòrag.mp3": 55746,
	"./Niall.mp3": 65240,
	"./Nirribhidh.mp3": 12966,
	"./Obar dheathain.mp3": 63374,
	"./Peairt.mp3": 89416,
	"./Port rìgh.mp3": 91297,
	"./Pàdraig.mp3": 6658,
	"./Ruairidh.mp3": 58234,
	"./Sealainn nuadh.mp3": 81577,
	"./Sealtainn.mp3": 11677,
	"./Seumas.mp3": 10449,
	"./Seòras.mp3": 22592,
	"./Sruighlea.mp3": 50098,
	"./Sìona.mp3": 14914,
	"./Tiriodh.mp3": 74091,
	"./Tormod.mp3": 30242,
	"./Uibhist.mp3": 73123,
	"./Uilleam.mp3": 72215,
	"./Uilleim.mp3": 40898,
	"./a bhalaich.mp3": 30854,
	"./a bhràthair.mp3": 63410,
	"./a charaid.mp3": 91320,
	"./a fàgail.mp3": 35724,
	"./a h-uile duine.mp3": 99200,
	"./a mhàthair.mp3": 86608,
	"./a phiuthar.mp3": 67008,
	"./a sheanair.mp3": 84313,
	"./a' bla bla bla.mp3": 31173,
	"./a' tuiteam.mp3": 2874,
	"./a-mach.mp3": 12244,
	"./a-muigh.mp3": 21222,
	"./a-màireach.mp3": 73597,
	"./a-nis.mp3": 38094,
	"./a-nochd.mp3": 88471,
	"./a-raoir.mp3": 57171,
	"./a-riamh.mp3": 76760,
	"./a-rithist.mp3": 93918,
	"./a-staigh.mp3": 84901,
	"./a-steach.mp3": 97499,
	"./abhainn.mp3": 45582,
	"./aca.mp3": 31030,
	"./ach.mp3": 37742,
	"./acras.mp3": 26690,
	"./ad.mp3": 25997,
	"./adhar.mp3": 43402,
	"./ag iarraidh.mp3": 95069,
	"./ag ionnsachadh.mp3": 19859,
	"./ag ithe.mp3": 24833,
	"./ag obair.mp3": 67711,
	"./ag èisteachd.mp3": 64181,
	"./ag òl.mp3": 25208,
	"./agad.mp3": 94249,
	"./agaibh.mp3": 35597,
	"./againn.mp3": 71999,
	"./agam.mp3": 2803,
	"./agus.mp3": 83748,
	"./aice.mp3": 60589,
	"./aig.mp3": 22490,
	"./aige.mp3": 57037,
	"./ailbhean.mp3": 61490,
	"./ailtire.mp3": 17135,
	"./aimearaga.mp3": 80089,
	"./ainm.mp3": 2670,
	"./ainmeil.mp3": 67501,
	"./air bhioran.mp3": 64786,
	"./air bòrd.mp3": 75360,
	"./air falbh.mp3": 90400,
	"./air leth.mp3": 33317,
	"./air.mp3": 86645,
	"./airgead.mp3": 56612,
	"./aiste.mp3": 70113,
	"./alba nuadh.mp3": 37458,
	"./alba.mp3": 2528,
	"./albannach.mp3": 89445,
	"./am-bliadhna.mp3": 51319,
	"./amadan.mp3": 71077,
	"./amar.mp3": 51832,
	"./amhach.mp3": 78422,
	"./an dèideadh.mp3": 61507,
	"./an dèidh.mp3": 71459,
	"./an gearasdan.mp3": 27238,
	"./an seo.mp3": 40575,
	"./an sin.mp3": 1035,
	"./an siud.mp3": 75837,
	"./an t-eilean sgitheanach.mp3": 3808,
	"./an t-uisge.mp3": 24863,
	"./an uairsin.mp3": 36351,
	"./an-asgaidh.mp3": 8577,
	"./an-diugh.mp3": 55908,
	"./an-dràsta.mp3": 57141,
	"./an-dè.mp3": 36913,
	"./ann an.mp3": 42053,
	"./annasach.mp3": 60957,
	"./antaidh.mp3": 44749,
	"./aodach.mp3": 41385,
	"./aodann.mp3": 10379,
	"./aois.mp3": 52133,
	"./aon bhàta.mp3": 75887,
	"./aon chàr.mp3": 14416,
	"./aon chù.mp3": 287,
	"./aon-deug.mp3": 94993,
	"./aon.mp3": 41469,
	"./aotrom.mp3": 61599,
	"./aran-milis.mp3": 17894,
	"./aran.mp3": 93808,
	"./asal.mp3": 26231,
	"./athair.mp3": 14910,
	"./b' àill leibh.mp3": 86316,
	"./baga.mp3": 82421,
	"./baile.mp3": 50086,
	"./bailtean.mp3": 81013,
	"./bainne.mp3": 47858,
	"./balach.mp3": 57837,
	"./ball iomain.mp3": 11839,
	"./ball-basgaid.mp3": 7176,
	"./ball-coise.mp3": 7226,
	"./ball.mp3": 67797,
	"./balla.mp3": 62914,
	"./banca.mp3": 54,
	"./barraigh.mp3": 28053,
	"./beag.mp3": 38267,
	"./beaga.mp3": 66621,
	"./bean.mp3": 45597,
	"./beartach.mp3": 9042,
	"./beatha.mp3": 4658,
	"./beathach.mp3": 68021,
	"./beathag.mp3": 78521,
	"./beathaichean.mp3": 56218,
	"./beul.mp3": 28325,
	"./beurla.mp3": 20803,
	"./beò.mp3": 41564,
	"./bhalaich.mp3": 79857,
	"./bhatarsaigh.mp3": 4713,
	"./bheat.mp3": 19908,
	"./bheataichean.mp3": 87309,
	"./bheil.mp3": 35369,
	"./bhruidhinn.mp3": 32882,
	"./bhràthair.mp3": 57375,
	"./bi.mp3": 39051,
	"./biadh.mp3": 95122,
	"./blasta.mp3": 31018,
	"./bliadhna.mp3": 50443,
	"./blàth.mp3": 77927,
	"./bochd.mp3": 11414,
	"./bodach.mp3": 52276,
	"./bodhaig.mp3": 19491,
	"./bog fliuch.mp3": 13051,
	"./bog.mp3": 22870,
	"./boireannach.mp3": 48370,
	"./bonaid.mp3": 92065,
	"./botal.mp3": 88703,
	"./bracaist.mp3": 88820,
	"./bradan.mp3": 83191,
	"./breugach.mp3": 12914,
	"./briogais.mp3": 53350,
	"./briste.mp3": 21382,
	"./broc.mp3": 16661,
	"./brochan.mp3": 56545,
	"./broilleach.mp3": 58194,
	"./brot.mp3": 57796,
	"./bruidhinn.mp3": 67530,
	"./bruis-fhiaclan.mp3": 9519,
	"./bruis.mp3": 62081,
	"./bràithrean.mp3": 98162,
	"./bràthair.mp3": 76534,
	"./brèagha.mp3": 62958,
	"./bròg.mp3": 80906,
	"./brònach.mp3": 98707,
	"./buidhe.mp3": 10302,
	"./bun-sgoil.mp3": 76651,
	"./buntàta.mp3": 34796,
	"./bus.mp3": 69907,
	"./busaichean.mp3": 95334,
	"./bàn.mp3": 19254,
	"./bàrd.mp3": 27569,
	"./bàta-luath.mp3": 78802,
	"./bàta.mp3": 96125,
	"./bàtaichean.mp3": 53521,
	"./bìodach.mp3": 65343,
	"./bò.mp3": 84837,
	"./bòidheach.mp3": 49857,
	"./bòrd-dubh.mp3": 42479,
	"./bòrd-geal.mp3": 79400,
	"./bòrd.mp3": 35932,
	"./bòtannan.mp3": 65234,
	"./cabhag.mp3": 22434,
	"./cadal.mp3": 65849,
	"./caileag.mp3": 61119,
	"./cailean.mp3": 3956,
	"./cailleach.mp3": 73081,
	"./cailleannach.mp3": 79788,
	"./cairteal an dèidh.mp3": 86339,
	"./cairteal gu.mp3": 50779,
	"./cait.mp3": 89397,
	"./calman.mp3": 67854,
	"./campadh.mp3": 72030,
	"./canada.mp3": 87352,
	"./caol.mp3": 6134,
	"./caora.mp3": 89613,
	"./capall-coille.mp3": 30593,
	"./caraid.mp3": 59162,
	"./caran.mp3": 43548,
	"./cas.mp3": 83743,
	"./cat-fiadhaich.mp3": 64384,
	"./cat.mp3": 89993,
	"./cathair.mp3": 66443,
	"./ceann.mp3": 75343,
	"./ceannach.mp3": 37814,
	"./ceap breatainn.mp3": 98364,
	"./ceapaire.mp3": 7417,
	"./cearban.mp3": 27400,
	"./cearc.mp3": 67802,
	"./ceart gu leòr.mp3": 81029,
	"./ceart.mp3": 59637,
	"./ceilteach.mp3": 97068,
	"./ceist.mp3": 16471,
	"./ceithir-deug.mp3": 2166,
	"./ceithir.mp3": 81754,
	"./ceàrr.mp3": 45936,
	"./ceòl.mp3": 54213,
	"./ceòthach.mp3": 8501,
	"./cha do sgrìobh.mp3": 37890,
	"./cha do.mp3": 72394,
	"./chaluim.mp3": 89205,
	"./charaid.mp3": 19221,
	"./cheannaich.mp3": 42219,
	"./cho.mp3": 97929,
	"./chuir.mp3": 32205,
	"./chàirdean.mp3": 45760,
	"./chì mi a-rithist thu.mp3": 49422,
	"./chì.mp3": 8149,
	"./cia mheud.mp3": 2682,
	"./ciamar a tha.mp3": 47728,
	"./cidsin.mp3": 57044,
	"./ciùin.mp3": 85015,
	"./clach.mp3": 98094,
	"./clachair.mp3": 75302,
	"./clachan-meallain.mp3": 53409,
	"./cladhach.mp3": 80271,
	"./clann.mp3": 85905,
	"./cleachd.mp3": 18808,
	"./cleachdadh.mp3": 60482,
	"./cleasaiche.mp3": 94155,
	"./cloc.mp3": 3117,
	"./cluas.mp3": 89078,
	"./cluich.mp3": 79536,
	"./cluiche.mp3": 91633,
	"./cluichibh.mp3": 84855,
	"./cluinntinn.mp3": 78546,
	"./cnatan.mp3": 76762,
	"./co-ogha.mp3": 36397,
	"./cofaidh.mp3": 57909,
	"./coibhneil.mp3": 80348,
	"./coille.mp3": 95003,
	"./coimhead.mp3": 99268,
	"./coimpiutair.mp3": 66386,
	"./coin.mp3": 98373,
	"./coineanach.mp3": 91356,
	"./coinneachadh.mp3": 40793,
	"./coiseachd.mp3": 46297,
	"./coisich.mp3": 93685,
	"./coisichibh.mp3": 75452,
	"./colaiste.mp3": 39502,
	"./coltach ri.mp3": 24207,
	"./coltach.mp3": 59214,
	"./coma.mp3": 20762,
	"./comasach.mp3": 32215,
	"./corrag.mp3": 72988,
	"./craobh.mp3": 97461,
	"./crios.mp3": 24245,
	"./croit.mp3": 97669,
	"./croitear.mp3": 35846,
	"./crosta.mp3": 25470,
	"./cruaidh.mp3": 8652,
	"./cruthachail.mp3": 78924,
	"./crùbag.mp3": 48727,
	"./cuan.mp3": 45899,
	"./cudromach.mp3": 66148,
	"./cugallach.mp3": 54859,
	"./cuideachadh.mp3": 10214,
	"./cuideachail.mp3": 39746,
	"./cuideachd.mp3": 25710,
	"./cuideigin.mp3": 41965,
	"./cuilean.mp3": 98336,
	"./cuimris.mp3": 37319,
	"./cuin.mp3": 67641,
	"./cuir.mp3": 3883,
	"./cumail.mp3": 39606,
	"./cumanta.mp3": 93826,
	"./cunnartach.mp3": 83323,
	"./cupa.mp3": 68045,
	"./cur.mp3": 73570,
	"./curran.mp3": 30557,
	"./cus.mp3": 28994,
	"./càirdeach.mp3": 45327,
	"./càirdeil.mp3": 29388,
	"./càise.mp3": 79164,
	"./càit a bheil.mp3": 73120,
	"./cànan soidhnidh bhreatainn.mp3": 26343,
	"./cànan.mp3": 11199,
	"./càr.mp3": 4378,
	"./cèic.mp3": 21759,
	"./cèilidh.mp3": 35893,
	"./cò.mp3": 22082,
	"./còcaire.mp3": 2807,
	"./còcaireachd.mp3": 63281,
	"./còig-deug.mp3": 91993,
	"./còig.mp3": 97609,
	"./còisir.mp3": 37144,
	"./còmhla ri.mp3": 30510,
	"./còmhla.mp3": 60890,
	"./còmhlan-ciùil.mp3": 68878,
	"./còrnais.mp3": 87810,
	"./còta.mp3": 12347,
	"./cù.mp3": 98449,
	"./damh.mp3": 51623,
	"./damhan-allaidh.mp3": 42251,
	"./dannsa gàidhealach.mp3": 23511,
	"./dannsa.mp3": 54699,
	"./dannsair.mp3": 2680,
	"./daor.mp3": 4827,
	"./dath.mp3": 82658,
	"./dathan.mp3": 57982,
	"./deagh.mp3": 20203,
	"./dealanaich.mp3": 51484,
	"./dealbh-chluich.mp3": 83214,
	"./dealbh.mp3": 48660,
	"./dealbhadair.mp3": 87100,
	"./dearg.mp3": 66127,
	"./dearga.mp3": 12384,
	"./deasg.mp3": 91846,
	"./deich.mp3": 56085,
	"./deigh.mp3": 66320,
	"./deise.mp3": 58285,
	"./deiseil.mp3": 30744,
	"./deoch.mp3": 10744,
	"./deònach.mp3": 77061,
	"./dh'aithghearr.mp3": 30064,
	"./dhachaigh.mp3": 34052,
	"./dhut.mp3": 50385,
	"./diardaoin.mp3": 8526,
	"./diciadain.mp3": 63093,
	"./dihaoine.mp3": 3504,
	"./diluain.mp3": 58937,
	"./dimàirt.mp3": 6842,
	"./dinnear.mp3": 55415,
	"./disathairne.mp3": 51961,
	"./do.mp3": 94281,
	"./doileag.mp3": 16683,
	"./doirbh.mp3": 32927,
	"./dol.mp3": 89136,
	"./dona.mp3": 36858,
	"./donn.mp3": 59068,
	"./doras.mp3": 23485,
	"./dorcha.mp3": 22780,
	"./dotair.mp3": 15554,
	"./dragh.mp3": 50386,
	"./draibh.mp3": 47595,
	"./draibheadh.mp3": 32283,
	"./drathais.mp3": 98753,
	"./dreasa.mp3": 28137,
	"./droch.mp3": 94906,
	"./drochaid.mp3": 53813,
	"./druim.mp3": 9734,
	"./dràma.mp3": 41535,
	"./dubh.mp3": 70725,
	"./duilich.mp3": 70029,
	"./duine.mp3": 54267,
	"./dà chàr.mp3": 61557,
	"./dà chù.mp3": 39790,
	"./dà mhionaid.mp3": 69216,
	"./dà uair dheug.mp3": 61285,
	"./dà uair.mp3": 3151,
	"./dà-dheug.mp3": 9751,
	"./dà.mp3": 77656,
	"./dè an uair a tha e.mp3": 36348,
	"./dè tha dol.mp3": 96558,
	"./dè.mp3": 9211,
	"./dèanamh.mp3": 33708,
	"./dèideag.mp3": 67842,
	"./dìcheallach.mp3": 90682,
	"./dìle.mp3": 38404,
	"./dìleas.mp3": 91774,
	"./dìosal.mp3": 9831,
	"./dìreach.mp3": 45717,
	"./dùinte.mp3": 77632,
	"./dùn dè.mp3": 39696,
	"./dùn èideann.mp3": 89751,
	"./dùn.mp3": 59216,
	"./e.mp3": 78387,
	"./each.mp3": 68340,
	"./eadailteach.mp3": 65923,
	"./eadar-lìon.mp3": 23993,
	"./eadar.mp3": 72771,
	"./eagal.mp3": 25216,
	"./eagalach.mp3": 9429,
	"./eaglais.mp3": 39089,
	"./eairdsidh.mp3": 84786,
	"./eala.mp3": 41613,
	"./eile.mp3": 45674,
	"./eilean.mp3": 81211,
	"./esan.mp3": 15870,
	"./eun.mp3": 57892,
	"./facal.mp3": 31872,
	"./faclair.mp3": 46307,
	"./fad an latha.mp3": 54104,
	"./fad.mp3": 69233,
	"./fada.mp3": 80036,
	"./fadalach.mp3": 38667,
	"./faiceallach.mp3": 84719,
	"./faicinn.mp3": 10661,
	"./faigh.mp3": 55938,
	"./faighinn.mp3": 79443,
	"./faireachdainn.mp3": 68153,
	"./faisg air.mp3": 25467,
	"./falamh.mp3": 39236,
	"./falbh.mp3": 87951,
	"./fallain.mp3": 69239,
	"./falt bàn.mp3": 9764,
	"./falt ruadh.mp3": 9901,
	"./falt.mp3": 51801,
	"./faoileag.mp3": 27564,
	"./farsaing.mp3": 79308,
	"./feamainn.mp3": 78513,
	"./feannag.mp3": 19824,
	"./fear.mp3": 80422,
	"./fearg.mp3": 38899,
	"./feasgar an-diugh.mp3": 48566,
	"./feasgar math.mp3": 92321,
	"./feasgar.mp3": 16388,
	"./feuchainn.mp3": 29720,
	"./feumaidh mi.mp3": 34383,
	"./feumaidh tu.mp3": 14974,
	"./feumaidh.mp3": 26601,
	"./feumail.mp3": 51699,
	"./feur.mp3": 43511,
	"./feòil.mp3": 85463,
	"./feòladair.mp3": 50116,
	"./feòrag.mp3": 63891,
	"./fhathast.mp3": 90163,
	"./fhrìseil.mp3": 56237,
	"./fiacaill.mp3": 65967,
	"./fiaclair.mp3": 84026,
	"./fiaclairean.mp3": 99175,
	"./fiadh.mp3": 56079,
	"./fiadhaich.mp3": 90050,
	"./fichead 's a....mp3": 23594,
	"./fichead.mp3": 24851,
	"./fidheall.mp3": 31927,
	"./fighe.mp3": 86613,
	"./fileanta.mp3": 5144,
	"./film.mp3": 21510,
	"./fionnlann.mp3": 15630,
	"./flat.mp3": 72953,
	"./fliuch.mp3": 58341,
	"./flùr.mp3": 72121,
	"./foghlam.mp3": 14866,
	"./foighidneach.mp3": 71087,
	"./forca.mp3": 91542,
	"./fosgailte.mp3": 55360,
	"./fraingis.mp3": 61410,
	"./frids.mp3": 90309,
	"./fuar.mp3": 26478,
	"./fuil.mp3": 9592,
	"./fuireach.mp3": 54053,
	"./furasta.mp3": 49961,
	"./fàgail.mp3": 45095,
	"./fàilte.mp3": 14669,
	"./fàs.mp3": 4424,
	"./fèileadh.mp3": 57787,
	"./fìon.mp3": 3219,
	"./fòn.mp3": 56474,
	"./gabh mo leisgeul.mp3": 7187,
	"./gabh.mp3": 69111,
	"./gabhail.mp3": 68112,
	"./gaol.mp3": 34705,
	"./gaothach.mp3": 94342,
	"./garbh.mp3": 64110,
	"./gasta.mp3": 55325,
	"./ge-tà.mp3": 67545,
	"./geal.mp3": 24812,
	"./gealach.mp3": 76348,
	"./geama-bùird.mp3": 68499,
	"./geama.mp3": 35835,
	"./geansaidh.mp3": 68356,
	"./gearmailtis.mp3": 91018,
	"./geàrr.mp3": 97041,
	"./ghalldachd.mp3": 3567,
	"./ghoid.mp3": 85557,
	"./ghrèig.mp3": 95230,
	"./ghàidhealtachd.mp3": 57573,
	"./giotàr.mp3": 53768,
	"./glainne.mp3": 39353,
	"./glan.mp3": 87669,
	"./glanadair.mp3": 18556,
	"./glanadh.mp3": 42532,
	"./glaodh.mp3": 58806,
	"./glas.mp3": 28368,
	"./glaschu.mp3": 78432,
	"./glasraich.mp3": 83786,
	"./gleann.mp3": 16453,
	"./gleansach.mp3": 75838,
	"./glic.mp3": 15812,
	"./glè bheag.mp3": 22854,
	"./glè mhath.mp3": 31653,
	"./glè mhòr.mp3": 28328,
	"./glè.mp3": 70109,
	"./glùn.mp3": 37660,
	"./gobhar.mp3": 80026,
	"./goid.mp3": 49454,
	"./goilf.mp3": 17445,
	"./goirid.mp3": 9209,
	"./goirt.mp3": 44848,
	"./gorm.mp3": 40811,
	"./greas ort.mp3": 43603,
	"./grian.mp3": 93272,
	"./grianach.mp3": 45133,
	"./gràin.mp3": 48761,
	"./gràineag.mp3": 28701,
	"./grànda.mp3": 22911,
	"./gu dearbh.mp3": 89295,
	"./gu leòr.mp3": 31182,
	"./gu math.mp3": 88564,
	"./guga.mp3": 12757,
	"./gàidhlig mhanainn.mp3": 50838,
	"./gàidhlig na h-èireann.mp3": 5359,
	"./gàidhlig.mp3": 11899,
	"./gàirdean.mp3": 80454,
	"./gàireachdainn.mp3": 59196,
	"./gàrradh.mp3": 63320,
	"./gòrach.mp3": 64431,
	"./h-uile.mp3": 68251,
	"./halò.mp3": 23970,
	"./hama.mp3": 52057,
	"./hiort.mp3": 43477,
	"./i.mp3": 26828,
	"./iad.mp3": 94067,
	"./iadsan.mp3": 84545,
	"./ialtag.mp3": 84007,
	"./iarann.mp3": 86591,
	"./iasg.mp3": 16121,
	"./iasgair.mp3": 33972,
	"./idir.mp3": 65458,
	"./inbhir nis.mp3": 11566,
	"./inntinneach.mp3": 77937,
	"./iomain.mp3": 8708,
	"./iongantach.mp3": 51418,
	"./ionnsaich.mp3": 49616,
	"./ionnsaichibh.mp3": 48131,
	"./isbean.mp3": 6633,
	"./ise.mp3": 42873,
	"./ist.mp3": 28088,
	"./ith.mp3": 55359,
	"./iuchair.mp3": 32542,
	"./lag.mp3": 51836,
	"./latha na sàbaid.mp3": 22512,
	"./latha.mp3": 15526,
	"./leabaidh.mp3": 20779,
	"./leabhar.mp3": 11302,
	"./leabharlann.mp3": 12817,
	"./leabhraichean.mp3": 77719,
	"./leanabh.mp3": 25815,
	"./leann.mp3": 88654,
	"./leasan.mp3": 14184,
	"./leat.mp3": 58648,
	"./leisg.mp3": 69706,
	"./leisgeadair.mp3": 98749,
	"./leth uair an dèidh.mp3": 55894,
	"./leugh.mp3": 69187,
	"./leughadh.mp3": 78342,
	"./leum.mp3": 55070,
	"./leumadair.mp3": 96774,
	"./leòdhas.mp3": 20017,
	"./leòmhann.mp3": 65018,
	"./liath.mp3": 35997,
	"./litir.mp3": 89657,
	"./loch.mp3": 69659,
	"./lofa.mp3": 7198,
	"./loidhne.mp3": 47030,
	"./lorg.mp3": 42770,
	"./losgann.mp3": 31118,
	"./luath.mp3": 44366,
	"./luch.mp3": 43989,
	"./luchd-lagha.mp3": 85438,
	"./luchd-saidheans.mp3": 2900,
	"./luchd-smàlaidh.mp3": 44875,
	"./lunnainn.mp3": 55396,
	"./lus.mp3": 53598,
	"./lusan.mp3": 54383,
	"./làidir.mp3": 7428,
	"./làmh.mp3": 98841,
	"./làn.mp3": 90561,
	"./làr.mp3": 37515,
	"./lèine-t.mp3": 83012,
	"./lèine.mp3": 25514,
	"./m' eudail.mp3": 16800,
	"./ma-thà.mp3": 84675,
	"./mac.mp3": 5504,
	"./madadh-allaidh.mp3": 3295,
	"./madaidhean-allaidh.mp3": 27760,
	"./madainn an-diugh.mp3": 17507,
	"./madainn mhath.mp3": 50670,
	"./madainn.mp3": 47507,
	"./maol.mp3": 54995,
	"./mapa.mp3": 96413,
	"./mar sin leat.mp3": 68721,
	"./mar-thà.mp3": 62955,
	"./marag-dhubh.mp3": 59909,
	"./marbh.mp3": 35686,
	"./margadh.mp3": 54309,
	"./matamataig.mp3": 86285,
	"./math air.mp3": 42885,
	"./math dhut.mp3": 31783,
	"./math.mp3": 90092,
	"./matha.mp3": 76156,
	"./mathan.mp3": 4115,
	"./meal do naidheachd.mp3": 13594,
	"./measan.mp3": 11058,
	"./mhadainn.mp3": 13497,
	"./mheanbh-chuileag.mp3": 63754,
	"./mhàthair.mp3": 24666,
	"./mi.mp3": 34413,
	"./mil.mp3": 64324,
	"./milis.mp3": 36097,
	"./ministear.mp3": 52748,
	"./mionaid.mp3": 40062,
	"./mions.mp3": 94711,
	"./miotagan.mp3": 46411,
	"./mise.mp3": 98747,
	"./mo chreach.mp3": 53561,
	"./mo.mp3": 1306,
	"./modhail.mp3": 41839,
	"./muc-mhara.mp3": 16557,
	"./muc.mp3": 64011,
	"./mucan.mp3": 67784,
	"./muga.mp3": 87746,
	"./muile.mp3": 88858,
	"./muir.mp3": 72402,
	"./màrtainn.mp3": 29966,
	"./màthair.mp3": 99403,
	"./mì-mhodhail.mp3": 37473,
	"./mìcheal.mp3": 76269,
	"./mìorbhaileach.mp3": 65514,
	"./mìos.mp3": 72940,
	"./mòine.mp3": 7864,
	"./mòr-bhùth.mp3": 86705,
	"./mòr.mp3": 63350,
	"./mòra.mp3": 39341,
	"./mòran taing.mp3": 33590,
	"./na gabh dragh.mp3": 18522,
	"./na gabh.mp3": 39270,
	"./na hearadh.mp3": 26706,
	"./na ith.mp3": 59358,
	"./na tog.mp3": 38964,
	"./naoi-deug.mp3": 7071,
	"./naoi.mp3": 57843,
	"./nas bòidhche.mp3": 87462,
	"./nas luaithe.mp3": 97698,
	"./nas truime.mp3": 57673,
	"./nas òige.mp3": 16839,
	"./nathair.mp3": 633,
	"./neach-bùtha.mp3": 60484,
	"./neach-ciùil.mp3": 63664,
	"./neach-frithealaidh.mp3": 18163,
	"./neach-lagha.mp3": 63237,
	"./neach-reic.mp3": 95528,
	"./neach-saidheans.mp3": 84544,
	"./neach-smàlaidh.mp3": 47840,
	"./neònach.mp3": 44297,
	"./nighean.mp3": 95212,
	"./niseag.mp3": 94234,
	"./no.mp3": 28748,
	"./nobhail.mp3": 93208,
	"./not.mp3": 13552,
	"./notaichean.mp3": 59777,
	"./nurs.mp3": 44102,
	"./nèill.mp3": 83023,
	"./obair-dachaigh.mp3": 66867,
	"./obair.mp3": 87551,
	"./obh obh.mp3": 31298,
	"./ochd-chasach.mp3": 50225,
	"./ochd-deug.mp3": 45531,
	"./ochd.mp3": 30247,
	"./oidhche mhath.mp3": 81044,
	"./oidhche.mp3": 24117,
	"./oifis.mp3": 24977,
	"./oighrig.mp3": 66217,
	"./oileanach.mp3": 71845,
	"./oileanaich.mp3": 29648,
	"./oilthigh.mp3": 74030,
	"./oirbh.mp3": 80579,
	"./oirnn.mp3": 14807,
	"./oirre.mp3": 13481,
	"./ollaimh.mp3": 97504,
	"./ollamh.mp3": 48248,
	"./onarach.mp3": 4031,
	"./orains.mp3": 54978,
	"./orainsear.mp3": 2023,
	"./orm.mp3": 64386,
	"./orra.mp3": 15431,
	"./ort.mp3": 96951,
	"./ospadal.mp3": 49636,
	"./paidh.mp3": 85011,
	"./partaidh.mp3": 64589,
	"./pathadh.mp3": 40999,
	"./peadar.mp3": 55406,
	"./peann.mp3": 12924,
	"./peant.mp3": 60297,
	"./peantadh.mp3": 56404,
	"./peata.mp3": 68543,
	"./peathraichean.mp3": 32686,
	"./phiuthar.mp3": 99998,
	"./phàdraig.mp3": 30378,
	"./phìob-mhòr.mp3": 74016,
	"./pinc.mp3": 40634,
	"./pinnt.mp3": 3253,
	"./piobar.mp3": 7734,
	"./piseag.mp3": 67033,
	"./piseagan.mp3": 76489,
	"./pitheid.mp3": 88529,
	"./piuthar.mp3": 18988,
	"./plèana.mp3": 31793,
	"./poileas.mp3": 24224,
	"./preas.mp3": 69625,
	"./pròiseil.mp3": 22494,
	"./purpaidh.mp3": 94077,
	"./putan.mp3": 67178,
	"./pàipear-naidheachd.mp3": 45695,
	"./pàipear.mp3": 4061,
	"./pàirc.mp3": 30737,
	"./pàrant.mp3": 49499,
	"./pòsta.mp3": 53656,
	"./radan.mp3": 59335,
	"./raonaid.mp3": 43710,
	"./rathad.mp3": 39350,
	"./ratharsair.mp3": 2756,
	"./reamhar.mp3": 84222,
	"./reic.mp3": 92338,
	"./reòite.mp3": 7792,
	"./reòiteag.mp3": 18462,
	"./reòthadh.mp3": 34189,
	"./ribh.mp3": 43851,
	"./rinn.mp3": 51690,
	"./ris.mp3": 27079,
	"./rithe.mp3": 11805,
	"./rium.mp3": 91925,
	"./riut.mp3": 96918,
	"./riutha.mp3": 94650,
	"./ro.mp3": 82897,
	"./rothair.mp3": 46180,
	"./rothaireachd.mp3": 86437,
	"./ruadh.mp3": 93916,
	"./rud.mp3": 45495,
	"./rudeigin.mp3": 74159,
	"./rugbaidh.mp3": 1836,
	"./ruith.mp3": 82766,
	"./ruithibh.mp3": 67725,
	"./runrig.mp3": 65512,
	"./rànaich.mp3": 47082,
	"./rèidio.mp3": 49453,
	"./rèis.mp3": 60783,
	"./rìs.mp3": 574,
	"./ròn.mp3": 15497,
	"./rùisgte.mp3": 68831,
	"./rùnaire.mp3": 30019,
	"./s e do bheatha.mp3": 7788,
	"./sabaid.mp3": 89088,
	"./sagart.mp3": 36326,
	"./saighdear.mp3": 38656,
	"./saighdearan.mp3": 86824,
	"./salach.mp3": 71011,
	"./salann.mp3": 65576,
	"./sam bith.mp3": 36545,
	"./saor.mp3": 74288,
	"./sasainn.mp3": 29892,
	"./seacaid.mp3": 79288,
	"./seachd-deug.mp3": 89302,
	"./seachd.mp3": 42129,
	"./seachdain.mp3": 88018,
	"./seada.mp3": 42397,
	"./sealg.mp3": 52835,
	"./seall air.mp3": 45973,
	"./seall.mp3": 24020,
	"./sean.mp3": 32964,
	"./seanair.mp3": 78859,
	"./seanmhair.mp3": 4999,
	"./seann.mp3": 68197,
	"./searbh.mp3": 49490,
	"./seas.mp3": 7641,
	"./seasamh.mp3": 14052,
	"./seilcheig.mp3": 89251,
	"./seinn.mp3": 48570,
	"./seinneadair.mp3": 87549,
	"./seinnibh.mp3": 28072,
	"./seo.mp3": 4596,
	"./seunta.mp3": 44411,
	"./seòclaid.mp3": 68742,
	"./seòladair.mp3": 36198,
	"./seòladh.mp3": 61092,
	"./seòlta.mp3": 50273,
	"./seòmar-cadail.mp3": 7921,
	"./seòmar-teagaisg.mp3": 90952,
	"./seòmar.mp3": 81116,
	"./sgadan.mp3": 73991,
	"./sgarbh.mp3": 94969,
	"./sgeilp.mp3": 48922,
	"./sgeulachd.mp3": 26414,
	"./sgian.mp3": 13307,
	"./sgileil.mp3": 99889,
	"./sgillinn.mp3": 93885,
	"./sgillinnean.mp3": 66990,
	"./sgioba.mp3": 51368,
	"./sgiobair.mp3": 59665,
	"./sgioblachadh.mp3": 99716,
	"./sgioblaich.mp3": 90831,
	"./sgiort.mp3": 95969,
	"./sgitheadh.mp3": 13306,
	"./sgoil.mp3": 64748,
	"./sgoilear.mp3": 50963,
	"./sgoinneil.mp3": 84053,
	"./sgrathail.mp3": 28255,
	"./sgreamhail.mp3": 28465,
	"./sgreuchail.mp3": 31913,
	"./sgriosail.mp3": 4541,
	"./sgrìobh.mp3": 65190,
	"./sgrìobhadair.mp3": 68261,
	"./sgrìobhadh.mp3": 51693,
	"./sgìth.mp3": 44334,
	"./sgòthach.mp3": 58105,
	"./sheanair.mp3": 67729,
	"./sheumais.mp3": 25258,
	"./shreap.mp3": 4219,
	"./sia-deug.mp3": 96512,
	"./sia.mp3": 50528,
	"./sibh.mp3": 48919,
	"./sibhse.mp3": 43631,
	"./sin thu fhèin.mp3": 19354,
	"./sin.mp3": 16010,
	"./sinn.mp3": 84429,
	"./sinne.mp3": 17633,
	"./sionnach.mp3": 27471,
	"./siud.mp3": 40344,
	"./siùcar.mp3": 27059,
	"./slaodach.mp3": 14336,
	"./slige.mp3": 76437,
	"./sligeanach.mp3": 21449,
	"./slàinte mhath.mp3": 33305,
	"./slàinte.mp3": 80880,
	"./smiogaid.mp3": 77250,
	"./sneachd.mp3": 80126,
	"./snog.mp3": 85940,
	"./snàmh.mp3": 6466,
	"./snèap.mp3": 78245,
	"./soilleir.mp3": 45602,
	"./soitheach.mp3": 66447,
	"./sona.mp3": 39226,
	"./spaideil.mp3": 82153,
	"./spainntis.mp3": 97202,
	"./speuclairean.mp3": 68976,
	"./sporan.mp3": 46769,
	"./spàin.mp3": 96952,
	"./spìosrach.mp3": 11023,
	"./spòrs.mp3": 74499,
	"./spòrsail.mp3": 19443,
	"./spùinneadair-mara.mp3": 43197,
	"./sreap.mp3": 10233,
	"./sràid.mp3": 89576,
	"./sròn.mp3": 45486,
	"./stad.mp3": 58599,
	"./staidhre.mp3": 62524,
	"./stais.mp3": 15423,
	"./stamag.mp3": 6801,
	"./steòrnabhagh.mp3": 87056,
	"./stiall ort.mp3": 28600,
	"./stocainnean.mp3": 84500,
	"./stèisean.mp3": 12027,
	"./suas.mp3": 96979,
	"./suidh.mp3": 45274,
	"./suidhe.mp3": 38476,
	"./suiteas.mp3": 39002,
	"./sàbhailte.mp3": 16262,
	"./sàmhach.mp3": 8656,
	"./sìde.mp3": 26225,
	"./sìonach.mp3": 52076,
	"./sìos.mp3": 14463,
	"./sùbh-làir.mp3": 86097,
	"./sùgh.mp3": 49840,
	"./sùil.mp3": 26466,
	"./taigeis.mp3": 65924,
	"./taigh-beag.mp3": 25993,
	"./taigh-bìdh.mp3": 49674,
	"./taigh-dhealbh.mp3": 8323,
	"./taigh-seinnse.mp3": 81397,
	"./taigh-solais.mp3": 75418,
	"./taigh-òsta.mp3": 26131,
	"./taigh.mp3": 44559,
	"./taingeil.mp3": 27232,
	"./talla-cluiche.mp3": 42771,
	"./talla.mp3": 83255,
	"./tapadh leat.mp3": 76815,
	"./tapadh leibh.mp3": 27406,
	"./tarbh.mp3": 23185,
	"./teagasg.mp3": 46178,
	"./teaghlach.mp3": 48738,
	"./teanas.mp3": 35405,
	"./teanga.mp3": 69313,
	"./teanta.mp3": 95415,
	"./teine.mp3": 97711,
	"./telebhisean.mp3": 1897,
	"./tha fios agam.mp3": 36158,
	"./tha gàidhlig agam.mp3": 48080,
	"./thalla.mp3": 26728,
	"./thidseir.mp3": 48668,
	"./thig a-steach.mp3": 32895,
	"./thoir dhomh.mp3": 96702,
	"./thormoid.mp3": 72247,
	"./thu.mp3": 27297,
	"./thuit.mp3": 87256,
	"./thusa.mp3": 43489,
	"./tidsear.mp3": 7736,
	"./tighinn.mp3": 26746,
	"./tinn.mp3": 4918,
	"./tiogaid.mp3": 29528,
	"./tioram.mp3": 76993,
	"./tog.mp3": 41326,
	"./togail.mp3": 41892,
	"./togalach.mp3": 90199,
	"./toilichte.mp3": 94851,
	"./toll.mp3": 5688,
	"./tomàto.mp3": 49514,
	"./tonn.mp3": 37025,
	"./trang.mp3": 81805,
	"./tric.mp3": 90579,
	"./trom.mp3": 77459,
	"./truinnsear.mp3": 13801,
	"./tràigh.mp3": 6872,
	"./tràth.mp3": 60404,
	"./trèana.mp3": 45792,
	"./trèanaichean.mp3": 37698,
	"./trì-deug.mp3": 53285,
	"./trì.mp3": 45258,
	"./tuathanach.mp3": 4947,
	"./tuathanas.mp3": 73183,
	"./tuigsinn.mp3": 55777,
	"./tuiteam.mp3": 7133,
	"./tunnag.mp3": 28062,
	"./turadh.mp3": 16295,
	"./tàileasg.mp3": 10303,
	"./tàirneanaich.mp3": 96790,
	"./tè.mp3": 22550,
	"./tì.mp3": 60458,
	"./tìde.mp3": 38162,
	"./tìoraidh an-dràsta.mp3": 5353,
	"./tìoraidh.mp3": 73080,
	"./tìr.mp3": 56749,
	"./tòn.mp3": 96066,
	"./uabhasach.mp3": 49829,
	"./uachdar.mp3": 81349,
	"./uaine.mp3": 85536,
	"./uair.mp3": 98984,
	"./uaireadair.mp3": 36620,
	"./uairean.mp3": 63519,
	"./uaireannan.mp3": 83202,
	"./uan.mp3": 2805,
	"./ubhal.mp3": 53393,
	"./ugh.mp3": 71581,
	"./uinneag.mp3": 53037,
	"./uinnean.mp3": 17173,
	"./uisge-beatha.mp3": 9212,
	"./uisge.mp3": 69251,
	"./uncail.mp3": 8381,
	"./àite.mp3": 43839,
	"./àlainn.mp3": 61753,
	"./àrd-sgoil.mp3": 9026,
	"./àrd-ùrlar.mp3": 36035,
	"./àrd.mp3": 78671,
	"./èibhinn.mp3": 93091,
	"./èirinn.mp3": 32255,
	"./èist.mp3": 35154,
	"./èistibh.mp3": 24654,
	"./ìle.mp3": 77976,
	"./ìm.mp3": 40263,
	"./òg.mp3": 56633,
	"./òinseach.mp3": 8604,
	"./òl.mp3": 48529,
	"./òran.mp3": 59585,
	"./òrd.mp3": 84235,
	"./ùghdar.mp3": 84428,
	"./ùr.mp3": 43295,
	"./ùra.mp3": 55629
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65983;